import config from '../../config/env';
import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useI18n } from '../../contexts/I18nContext';
import './DarkModeToggle.css';

export const DarkModeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const { t } = useI18n();

  const handleToggle = () => {
    toggleTheme();

    if (config.dev.debug) {
      console.log('[THEME DEBUG] Switched to:', !isDark ? 'dark' : 'light');
    }
  };

  return (
    <div className="dark-mode-toggle">
      <div className="dark-mode-toggle-container">
        <span className={`dark-mode-icon sun ${!isDark ? 'active' : ''}`}>
          ☀️
        </span>

        <label className="dark-mode-switch">
          <input
            type="checkbox"
            checked={isDark}
            onChange={handleToggle}
            aria-label={t('theme.toggleDarkMode')}
          />
          <span className="dark-mode-slider"></span>
        </label>

        <span className={`dark-mode-icon moon ${isDark ? 'active' : ''}`}>
          🌙
        </span>
      </div>
    </div>
  );
};